<template>
    <div id="footer" :class="{'darkFooter': darkMode}">
        <main>  
            <div id="subscribe" :class="{'darkSubscribe': darkMode}">
               <div>
                    <h2 class="subtitle">{{ text }}</h2>
                    <p class="text">Cuéntanos tu idea y te respondemos rápido.</p>
                </div>
                <router-link class="button" to="/contact">Solicita tu cotización</router-link>
            </div>
        </main>
        <footer class="container">
            <div>
                <img :src="darkMode ? require('../assets/SELK_LOGO_DARK.svg') : require('../assets/SELK_LOGO_2.svg')" alt="Logo dinámico" />
                <p class="text">Selk, una empresa especializada en software empresarial y fabricación 3D, comprometida con los más altos estándares de calidad.</p>
            </div>
            <div>
                <div>
                    <h2 class="text">Soluciones</h2>
                    <ul class="text">
                        <li><router-link to="/services" class="text">Aplicativos y automatización</router-link></li>
                        <li><router-link to="/print3d" class="text">Impresión 3D</router-link></li>
                    </ul>
                </div>
                <div>
                    <h2 class="text">Empresa</h2>
                    <ul class="text">
                        <li><router-link to="/us" class="text">Acerca de nosotros</router-link></li>
                        <li><router-link to="/contact" class="text">Contáctanos</router-link></li>
                    </ul>
                </div>
                <div>
                    <h2 class="text">Empieza</h2>
                    <ul class="text">
                        <li><router-link to="/contact" class="text">Solicita tu cotización</router-link></li>
                        <li><router-link to="/print3d" class="text">Cotiza tu impresión 3D</router-link></li>
                        <li><router-link to="/admin" class="text access-clientes">Acceso clientes</router-link></li>
                    </ul>
                </div>
            </div>
        </footer>

        <div class="footer-bottom container">
            <p class="footer-copy text">© {{ year }} Selk. Todos los derechos reservados.</p>

            <ul class="footer-legal">
                <li><router-link to="/privacidad" class="text">Política de privacidad</router-link></li>
                <li><router-link to="/terminos" class="text">Términos y condiciones</router-link></li>
            </ul>

            <!-- Redes sociales: se muestran solo si hay URL configurada, para no
                 publicar enlaces rotos (VUE_APP_INSTAGRAM_URL). -->
            <ul v-if="instagramUrl" class="footer-social">
                <li>
                    <a
                        :href="instagramUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Selk en Instagram"
                    >
                        <Instagram :size="22" :stroke-width="2" />
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router'
import { Instagram } from 'lucide-vue-next';
export default {
    name: 'FooterPage',
    components: { Instagram },
    setup() {
        const route = useRoute();
        const darkMode = computed(() => route.path === '/onibi');
        const year = new Date().getFullYear();
        const instagramUrl = process.env.VUE_APP_INSTAGRAM_URL || '';

        return { darkMode, year, instagramUrl };
    },
    props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
footer a {
  text-decoration: none;
  color: inherit;
  transition: color 0.3s, border-bottom 0.3s;
}

footer a:hover {
  color: #2e8a99;
  border-bottom: 2px solid #2e8a99;
}

h2 {
    font-weight: 700;
}

#footer {
    background: #F8F8F8;
    /* El hueco inferior reserva el sitio del botón flotante de WhatsApp
       (`position: fixed; bottom: 5%; height: 65px`): sin él se sienta sobre la
       barra legal, que es lo último que se ve al llegar al final. El cálculo
       sigue su geometría, así que aguanta cualquier alto de ventana. */
    padding: 0 0 calc(5vh + 4.5rem) 0;
    justify-content: center;
}

footer button {
    background: none;
    border: none;
    cursor: pointer;
    color:  #4F5665;
    border-bottom: 2px solid transparent;
}

footer button:hover {
    border-bottom: 2px solid #4F5665;
    transition: border-color 0.3s;
    box-sizing: border-box;
}

main {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

#subscribe {
    display: flex;
    background-color: white;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-md);
    text-align: center;
    /* Sube sobre la banda gris del footer; el hueco que deja lo reserva
       #page-content con --footer-card-pull. */
    margin: calc(-1 * var(--footer-card-pull)) 2vw 4vw 2vw;
    /* El aire interior lo pone la tarjeta, no los márgenes de sus hijos: con
       `margin-left` en el texto el botón quedaba pegado al borde y el radio de
       50px lo recortaba visualmente. */
    padding: var(--space-md) clamp(1.5rem, 4vw, 4rem);
    box-sizing: border-box;
    z-index: 1;
    width: 90%;
    border-radius: 50px;
}

#subscribe > div {
    display: flex;
    flex-direction: column;
    text-align: left;
    align-content: flex-start;
    width: 50%;
    margin: 0;
}

#subscribe > div > h2 {
    margin-top: 0;
    margin-bottom: 0;
}

#subscribe > div > p {
    margin: 0.4rem 0 0;
}

#subscribe > .button {
    flex-shrink: 0;
}

footer{
    display: flex;
    flex-direction: row;
}

footer > div:first-of-type {
    display: flex;
    flex-direction: column;
    width: 30vw;
    margin: auto 10vw auto 1vw;
    text-align: left;
}
footer > div:first-of-type > img {
    height: auto;
    width: 70%;
}
footer > div:nth-of-type(2) {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding: 2vw 0 0 0;
}
footer > div:nth-of-type(2) > div {
    margin: 2vw;
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: start;
}

li {
    margin: 0.5vw 0 0.5vw 0;
    text-align: start;
}

/* ---------- Barra legal inferior ---------- */
.footer-bottom {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 2vw;
    padding-top: 1.5rem;
    border-top: 1px solid #9DB2BF;
}

.footer-copy {
    margin: 0;
    font-size: 16px !important;
}

.footer-legal {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
}

.footer-legal li {
    margin: 0;
}

.footer-legal a {
    font-size: 16px !important;
}

.footer-social {
    display: flex;
    gap: 1rem;
}

.footer-social li {
    margin: 0;
}

.footer-social a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #9DB2BF;
    color: #4F5665;
}

.footer-social a:hover {
    color: #2e8a99;
    border-color: #2e8a99;
    border-bottom-width: 1px;
}

.darkFooter {
    background-color: rgba(20,20,20,1) !important;
    color: white;
}

.darkFooter .footer-bottom {
    border-top-color: rgba(255, 255, 255, 0.15);
}

.darkFooter .footer-social a {
    border-color: rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.85);
}
.darkSubscribe {
    background-color: rgba(71, 70, 70, 1)    !important;
    color: white;
}
.darkSubscribe .button {
    background-color: rgba(46, 138, 153, 1) !important;
    color: white !important;
    box-shadow: 0px 8px 20px rgba(255, 255, 255, 0.4);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.darkSubscribe .button:hover {
    transform: translateY(-3px);
    box-shadow: 0px 12px 25px rgba(255, 255, 255, 0.6);
}

@media (max-width: 800px){
    .subtitle {
        font-size: 1.5rem;
    }
    #subscribe{
        border-radius: 30px;
    }
    #subscribe {
        flex-direction: column;
        width: 90%;
    }
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0;
    }
    #subscribe > div {
    width: 100%;
    margin: 0 !important;
    text-align: center;
    }
    #subscribe > div > h2,
    #subscribe > div > p {
        text-align: center;
    }
    footer{
        flex-direction: column;
    }
    footer > div:first-of-type {
        width: 80%;
        align-content: center;
    }
    footer > div:nth-of-type(2) {
        flex-wrap: wrap;
        margin: 0;
        justify-content: center;  
    }
    h2,p{
        text-align: center;
        line-height:25px;
    }
    /* En columna, el respiro entre el texto y el CTA lo da el `gap`; el margen
       inferior sobraba y descentraba la tarjeta. */
    #subscribe > .button {
        margin-bottom: 0;
    }
}

</style>